(() => {
  function init(root) {
    if (root.dataset.ggBisReady) return;
    const source = root.querySelector('[data-gg-bis-config]');
    if (!source) return;
    let config;
    try { config = JSON.parse(source.textContent); } catch (_) { return; }
    if (!config.companyId || !Array.isArray(config.variants)) return;
    const form = root.querySelector('[data-gg-bis-form]');
    const email = form.querySelector('input[type="email"]');
    const submit = form.querySelector('[data-gg-bis-submit]');
    const status = form.querySelector('[data-gg-bis-status]');
    const size = root.querySelector('[data-gg-bis-size]');
    const support = root.querySelector('[data-gg-bis-support]');
    const variants = new Map(config.variants.map(v => [String(v.id), v]));
    let selected = variants.get(root.dataset.variantId);
    let busy = false;
    const accepted = new Set();
    function message(text, error = false) {
      status.textContent = text;
      status.hidden = !text;
      status.classList.toggle('is-error', error);
    }
    function select(id) {
      const variant = variants.get(String(id));
      if (!variant) return;
      const changed = selected && String(selected.id) !== String(variant.id);
      selected = variant;
      root.dataset.variantId = String(variant.id);
      root.hidden = Boolean(variant.available);
      size.textContent = variant.title;
      submit.disabled = busy || Boolean(variant.available);
      if (changed && !busy) message('');
      const inquiry = new URL(support.getAttribute('href'), location.origin);
      inquiry.searchParams.set('subject', `${config.productTitle} — ${variant.title} availability`);
      support.href = inquiry.href;
    }
    document.addEventListener('variant:change', event => {
      const variant = event.detail && event.detail.variant;
      if (variant && variants.has(String(variant.id))) select(variant.id);
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      if (form.elements.company_website.value) return;
      if (!selected || selected.available) { message(config.text.unavailable, true); return; }
      const requested = selected;
      const address = email.value.trim();
      const key = `${requested.id}:${address.toLowerCase()}`;
      const successText = config.text.success.replace('[size]', requested.title);
      if (accepted.has(key)) { message(successText); return; }
      busy = true;
      submit.disabled = true;
      submit.textContent = config.text.sending;
      form.setAttribute('aria-busy', 'true');
      message('');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(config.companyId)}`, {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: {'Content-Type': 'application/json', 'revision': '2026-07-15'},
          body: JSON.stringify({data: {type: 'back-in-stock-subscription', attributes: {
            profile: {data: {type: 'profile', attributes: {email: address}}}, channels: ['EMAIL']
          }, relationships: {variant: {data: {type: 'catalog-variant', id: `$shopify:::$default:::${requested.id}`}}}}})
        });
        if (response.status !== 202) throw new Error(response.status === 429 ? config.text.rate_limit : response.status === 400 ? config.text.invalid : config.text.error);
        accepted.add(key);
        message(successText + (String(selected.id) !== String(requested.id) ? ' ' + config.text.changed.replace('[size]', selected.title) : ''));
      } catch (error) {
        message(error.name === 'AbortError' || error instanceof TypeError ? config.text.error : error.message || config.text.error, true);
      } finally {
        clearTimeout(timer);
        busy = false;
        submit.disabled = Boolean(selected.available);
        submit.textContent = config.text.submit;
        form.removeAttribute('aria-busy');
      }
    });
    const initialId = new URLSearchParams(location.search).get('variant');
    select(initialId && variants.has(initialId) ? initialId : root.dataset.variantId);
    root.dataset.ggBisReady = 'true';
    form.hidden = false;
  }
  document.querySelectorAll('[data-gg-bis]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gg-bis]').forEach(init));
})();
